<template>
  <div>
    <!-- -->
  </div>
</template>

<script setup>
import { ref } from 'vue';

const feature = ref();
</script>
